import { FilterOperator } from '@progress/kendo-data-query';
import { CPS_FIELD_TYPE, CpsFieldType, CpsFilterRequest } from '@cs-cms/types';
import { getGearDateFilterFormat } from '@cs-cms/utils';
import dayjs from 'dayjs';
import { SapInvoiceFilterParam } from './parseSapInvoiceSearchParams';

const SAP_FIELD_TYPES: Record<string, CpsFieldType> = {
  CompanyCode: CPS_FIELD_TYPE.TEXT,
  SupplierSIREN: CPS_FIELD_TYPE.TEXT,
  InvoiceNumber: CPS_FIELD_TYPE.TEXT,
  InvoiceDate: CPS_FIELD_TYPE.DATE
};

const PROXY_OPERATOR_TO_FILTER_OPERATOR: Record<string, FilterOperator> = {
  eq: 'eq' as FilterOperator,
  ge: 'gte' as FilterOperator,
  le: 'lte' as FilterOperator,
  gt: 'gt' as FilterOperator,
  lt: 'lt' as FilterOperator,
  neq: 'neq' as FilterOperator,
  gte: 'gte' as FilterOperator,
  lte: 'lte' as FilterOperator
};

const resolveFieldType = (fieldName: string): CpsFieldType => {
  return SAP_FIELD_TYPES[fieldName] ?? CPS_FIELD_TYPE.TEXT;
};

const mapOperator = (op: string): FilterOperator | null => {
  return PROXY_OPERATOR_TO_FILTER_OPERATOR[op.toLowerCase()] ?? null;
};

const formatFilterValue = (fieldType: CpsFieldType, operator: FilterOperator, value: string): string => {
  if (fieldType !== CPS_FIELD_TYPE.DATE && fieldType !== CPS_FIELD_TYPE.DATETIME) {
    return value;
  }

  const parsedDate = dayjs(value);
  if (!parsedDate.isValid()) {
    return value;
  }

  if (operator === ('lte' as FilterOperator) || operator === ('le' as FilterOperator)) {
    return getGearDateFilterFormat(parsedDate.endOf('day').toDate());
  }

  if (operator === ('gte' as FilterOperator) || operator === ('ge' as FilterOperator)) {
    return getGearDateFilterFormat(parsedDate.startOf('day').toDate());
  }

  return getGearDateFilterFormat(parsedDate.toDate());
};

export const buildSapInvoiceFilters = (params: SapInvoiceFilterParam[]): CpsFilterRequest[] | null => {
  const filters: CpsFilterRequest[] = [];

  for (const param of params) {
    const operator = mapOperator(param.op);
    if (operator == null) {
      return null;
    }

    const fieldType = resolveFieldType(param.field);
    filters.push({
      fieldName: param.field,
      operator,
      values: [formatFilterValue(fieldType, operator, param.value)],
      fieldType
    });
  }

  return filters;
};
